import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTime = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M11 7v6.5h6v-2h-4V7h-2z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0zm-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0z",
		clipRule: "evenodd"
	})]
});
export default SvgTime;
